import * as actions from "./actions";
import { Map, fromJS, Set, List } from "immutable";

function reducer(state = List(), action) {
  switch (action.type) {
    case "DISCOUNT_FETCH_SUCCESSFULLY":
      return fromJS(action.discounts);
    default:
      return state;
  }
}

export default reducer;



// WEBPACK FOOTER //
// src/model/DiscountCode/reducer.js